import iconCategoryBack from '@/core/assets/images/icons/category-back.svg';

const CategoryTitle = ({ props, listeners, scopedSlots }) => {
    const { showIconBack, name, id, hits } = props;

    const onClickIconBack = (event) => {
        listeners['click-icon-back'](event);
    };

    const onClickTitle = (event) => {
        listeners['click-title'](event);
    };

    return <h2 class="l-ss-c-results-categories-category-title">
        {scopedSlots.path &&
            <div class="l-ss-c-results-categories-category-title-path">
                {scopedSlots.path()}
            </div>
        }

        <div class="l-ss-c-results-categories-category-title-inner">
            {showIconBack &&
                <i
                    class="l-ss-c-icon l-ss-c-icon-category-back"
                    domPropsInnerHTML={iconCategoryBack}
                    onClick={onClickIconBack}>
                </i>
            }

            <span
                class="l-ss-c-results-categories-category-title-value"
                title={name}
                onClick={onClickTitle}
                domPropsInnerHTML={name || id}>
            </span>

            {hits &&
                <span class="l-ss-c-count-tag">
                    {hits}
                </span>
            }
        </div>
    </h2>;
};

CategoryTitle.props = {
    showIconBack: {
        type: Boolean,
    },
    name: {
        type: String,
    },
    id: {
        type: String,
    },
    hits: {
        type: [Number, String],
    },
};

export default CategoryTitle;
